  function getShippingRates() {
    var zip = document.getElementById('zipcode').value.replace(/\D/g,'');
    var price = document.getElementsByClassName('price-item')[0].innerHTML.replace(/\D/g,'');
    var shippingResult = '';
    
    if (zip) {
        let _data = {
            key: 'asTdknRj98q31dCC973xNa',
            zipcode: zip,
            price: price
        }
        fetch('https://app.puzi.com.br/shipping/', {
            method: 'POST',
            headers: {'Content-type': 'application/json'},
            body: JSON.stringify(_data)
        }).then(response => response.text()).then(data => {
            data = JSON.parse(data);
            if(data.invalid==1) {
                  alert('Por favor, insira um CEP válido.');  
            } else {
            data.rates.forEach(function(e) {
                if(e.total_price>0) {
                  quote = "R$ "+(e.total_price/100).toFixed(2).replace('.',',');
                } else {
                  quote = "Grátis";
                }
                shippingResult += "<b>"+e.service_name+":</b> "+e.description+" ("+quote+")<br>";
            });
            document.getElementsByClassName('shippingResult')[0].innerHTML = shippingResult;
            document.getElementsByClassName('shippingResult')[0].classList.remove("hide");
            }
         });
    } else {
        alert('Por favor, insira um CEP válido.');
    }
  }  

  document.getElementById('getQuote').addEventListener("click", function(e) {
    e.preventDefault();
    var shippingEstimate = document.getElementById("shipQuote");
    document.getElementById('getQuote').classList.add("hide");
    shippingEstimate.classList.remove("hide");
  });